(function () {
  function initTrustBar(root) {
    var items = root.querySelectorAll('.cellfy-trust-item');
    if (items.length < 2) return;

    var speed = parseInt(root.dataset.rotateSpeed, 10) || 4000;
    var current = 0;

    items.forEach(function (item, i) {
      item.classList.toggle('is-active', i === 0);
    });

    setInterval(function () {
      items[current].classList.remove('is-active');
      current = (current + 1) % items.length;
      items[current].classList.add('is-active');
    }, speed);
  }

  function init() {
    document.querySelectorAll('[data-cellfy-trust-bar]').forEach(function (root) {
      if (root.dataset.cellfyTrustBarInit === 'true') return;
      root.dataset.cellfyTrustBarInit = 'true';
      initTrustBar(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();